import { AccountDocument } from 'types';

export const hasMaxMonthlyPaymentCap = (account: AccountDocument | undefined): boolean => {
  const cap = account?.monthlyPaymentCap;
  if (!cap) return false;
  const { orgMaxZeroEscalationRate, orgMaxGreaterThanZeroEscalationRate } = cap;
  if (!orgMaxZeroEscalationRate || !orgMaxGreaterThanZeroEscalationRate) return false;
  return (
    cap.greaterThanZeroEscalationRate === orgMaxGreaterThanZeroEscalationRate &&
    cap.zeroEscalationRate === orgMaxZeroEscalationRate
  );
};
